<template>
    <v-row v-if="selectedMaterial">
        <div class="image-container">
            <img
                v-if="selectedMaterial.parent.images_array && selectedMaterial.parent.images_array != '[]' && JSON.parse(selectedMaterial.parent.images_array)"
                :src="JSON.parse(selectedMaterial.parent.images_array)[0]"
            />
            <!-- <div class="carousel-container">
                <v-carousel class="carousel" v-if="selectedMaterial.parent.images_array != '[]'" show-arrows="hover" progress="primary" >
                    <v-carousel-item 
                        v-for="(image_src, index) in JSON.parse(selectedMaterial.parent.images_array)" :key="index"
                    > 
                        <img class="carousel-image" style="width: 100%; cursor: pointer;" :src="image_src" @click="displayPhotoInDialog" />
                    </v-carousel-item>
                </v-carousel>
                <div id="no-image-stored" style="margin-top: 20px;" v-else>No image</div>
            </div> -->
            <div id="no-image-stored" style="margin-top: 20px" v-else>
                No image
            </div>
        </div>
        <div class="material-description-container">
            <div class="material-description-container-row">
                
                <div class="data-piece">
                    <p class="title">Title:</p>
                    <p class="value">{{ selectedMaterial.parent.title }}</p>
                </div>
                

                <div class="data-piece">
                    <p class="title">Material Type:</p>
                    <p class="value">{{ selectedMaterial.parent.type_cached }}</p>
                </div>
                
                <div class="data-piece">
                    <p class="title">Thickness:</p>
                    <p class="value">
                        {{ selectedMaterial.parent.thickness
                        }}<span style="font-size: 12px">{{
                            selectedMaterial.parent.thickness_um
                        }}</span>
                    </p>
                </div>
                
                <div class="data-piece">
                    <p class="title">Finish:</p>
                    <p class="value" v-if="selectedMaterial.parent.finish_id">
                        {{ selectedMaterial.parent.finish_cached }}
                    </p>
                </div>

                <div class="data-piece">
                    <p class="title">Carbon Emissions:</p>
                    <p class="value">{{ selectedMaterial.parent.carbon_emissions }}</p>
                </div>
                <div class="data-piece">
                    <p class="title">Samples in Stock:</p>
                    <p class="value">{{ locationName ? locationName + ': ' : '' }}<span style="font-weight: 700;">{{ locationName ? inStock : '' }}</span></p>
                </div>

                <div class="data-piece">
                    <p class="title">Color:</p>
                    <!-- <p class="value" v-if="selectedMaterial.color_id">
                        {{ selectedMaterial.color_cached }}
                    </p> -->

                    <v-select
                        v-model="selectedMaterial.id"
                        variant="underlined"
                        :items="existingColors"
                        item-title="title"
                        item-value="value"
                        :menu-props="{
                            maxHeight: 350,
                        }"
                        @update:modelValue="changeColor"
                    >
                        <template #selection="{ item }">
                            <v-chip
                                variant="elevated"
                                theme="light"
                                color="black"
                                >{{ item.title }}
                            </v-chip>
                        </template>
                    </v-select>
                </div>

                <div class="data-piece">
                    <p class="title">Material ID:</p>
                    <p class="value">{{ selectedMaterial.mid }}</p>
                </div>
            </div>

            <div class="material-description-container-row">
                <div class="data-piece-2">
                    <p class="title">properties:</p>
                    <p class="value">
                        {{
                            selectedMaterial.parent.properties_array
                                .replace(new RegExp(",", "g"), ", ")
                                .replace("[", "")
                                .replace("]", "")
                                .replace(new RegExp('"', "g"), "")
                        }}
                    </p>
                </div>

                <div class="recyclables-container">
                    <div class="bucket">
                        <p class="title">Recycled:</p>
                        <p class="value">
                            {{
                                selectedMaterial.parent.recycled === 1
                                    ? "Y"
                                    : selectedMaterial.parent.recycled === 0
                                    ? "N"
                                    : "N/A"
                            }}
                        </p>
                    </div>
                    <div class="bucket">
                        <p class="title">Recyclable:</p>
                        <p class="value">
                            {{
                                selectedMaterial.parent.recyclable === 1
                                    ? "Y"
                                    : selectedMaterial.parent.recyclable === 0
                                    ? "N"
                                    : "N/A"
                            }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="material-bottom-container">
            <div class="notes-addition-container">
                <div
                    class="notes-container"
                    v-if="selectedMaterial.parent.additional_information"
                >
                    <p class="title">Additional Information:</p>
                    <span class="value" style="white-space: pre">{{
                        selectedMaterial.parent.additional_information
                    }}</span>
                </div>
                <div class="notes-container" v-if="selectedMaterial.parent.test_id">
                    <p class="title">Notes:</p>
                    <span class="value" style="white-space: pre">{{
                        selectedMaterial.parent.test.general_notes
                    }}</span>
                </div>
            </div>
        </div>

        <h3 style="width: 100%; text-align: center; text-decoration: underline;" v-if="vendorData">Vendor Details</h3>
        <div class="material-description-container-vendor" v-if="vendorData">
            <div class="data-piece">
                <p class="title">Vendor:</p>
                <p class="value">{{ vendorData.vendor_cached }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Production Spec:</p>
                <p class="value" v-if="vendorData.production_spec_id">
                    {{ vendorData.production_spec_cached }}
                </p>
            </div>
            <div class="data-piece">
                <p class="title">Availability:</p>
                <p class="value">{{ vendorData.availability }}</p>
            </div>
            <div class="data-piece">
                <p class="title">MOQ:</p>
                <p class="value">{{ vendorData.moq }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Color Matching:</p>
                <p class="value">{{ vendorData.color_matching }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Type:</p>
                <p class="value">{{ vendorData.is_vendor ? 'Reseller' : (vendorData.is_manufactor ? 'Manufacturer' : null) }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Production Lead Time:</p>
                <p class="value">{{ vendorData.production_lead_time }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Production Capacity:</p>
                <p class="value">{{ vendorData.production_capacity }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Price:</p>
                <p class="value">{{ vendorData.price }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Form:</p>
                <p class="value">{{ vendorData.form }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Origin:</p>
                <p class="value">{{ vendorData.origin }}</p>
            </div>
            <div class="data-piece">
                <p class="title">Stock:</p>
                <p class="value">{{ vendorData.stock }}</p>
            </div>
        </div>
    </v-row>

    <v-row v-if="selectedMaterial && selectedMaterial.parent.test_id">
        <v-col :cols="screenType === 'mobile' ? '12' : '4'">
            <p id="download-button" @click="downloadPdf()">
                Download Test Results
            </p>
        </v-col>
    </v-row>

    <v-dialog v-model="dialogs.imageDisplay" max-width="1000">
        <v-card>
            <v-card-text>
                <img
                    id="imageDisplayImageTag"
                    src="#"
                    style="width: 100%; height: 100%"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="primary"
                    block
                    @click="dialogs.imageDisplay = false"
                    >Close</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import { useMaterials } from "../../stores/Design/Materials";
import { mapWritableState } from "pinia";

export default {
    name: "ViewMaterial",
    props: {
        material: {
            type: Object,
            default: null,
        },
        materialId: {
            type: Number,
            default: null
        }
    },
    components: {
        //
    },
    data() {
        return {
            screenType: "desktop",
            selectedMaterial: null,
            siblings: null,
            existingColors: [],
            locationName: null,
            c: null,
            vendorData: null,
            dialogs: {
                imageDisplay: false,
            },
        };
    },
    async mounted() {
        this.checkScreenWidth();
        let id = this.materialId ?? this.material.id
        await this.findMaterial(id);
        // this.setLocationDetails();
        // this.setVendorDetails();
    },
    computed: {
        ...mapWritableState(useMaterials, [
            "selectedCountryCode"
        ]),
        countryCode() {
            return this.selectedCountryCode ? this.selectedCountryCode : `${this.$page.props.auth.user.countryCodeFK}`.trim();
        }
    },
    watch: {
        // This gets changed a lot
        // Whenever the refreshBomBool is changed we then re-render the entire view by fetching all the data from scratch 
        selectedCountryCode(value, oldValue) {
            this.setVendorDetails();
            this.setLocationDetails();
        }
    },
    methods: {
        changeColor(materialId) {
            this.findMaterial(materialId);
            
        },
        async findMaterial(id) {
            let fetchMaterial = axios.create({
                headers: {
                    countryCodeFK: this.countryCode,
                    materialId: id
                },
            });

            await fetchMaterial
                .get(route("api.materials.find-one"))
                .then((response) => {
                    this.selectedMaterial = response.data.material;
                    this.siblings = response.data.siblings;

                    this.existingColors = this.siblings.map(function(sib) {
                        return {value: sib.id, title: sib.color_cached};
                    });

                    this.setLocationDetails();
                    this.setVendorDetails();
                });
        },
        setVendorDetails() {
            this.vendorData = null;
            if (this.selectedMaterial.parent.vendors.length > 0) {
                this.selectedMaterial.parent.vendors.forEach((vendorRow) => {
                    if (vendorRow.country_code === this.countryCode) {
                        this.vendorData = vendorRow;
                    }
                })
            }
        },
        setLocationDetails() {
            let fetchLocationsHeaders = axios.create({
                headers: {
                    materialId: this.selectedMaterial.id,
                    countryCodeFK: this.countryCode
                },
            });

            fetchLocationsHeaders
                .get(route("api.materials.getLocations"))
                .then((response) => {
                    if (response.data.found) {
                        this.locationName = response.data.title;
                        this.inStock = response.data.quantity;

                    } else {
                        this.locationName = null;
                        this.inStock = null;
                    }
                }).catch((err) => {
                    console.log('error: ', err)
                })
        },
        checkScreenWidth() {
            let width = screen.width;
            if (width < 750) {
                this.screenType = "mobile";
            } else if (width < 1000) {
                this.screenType = "tablet";
            }
        },
        displayPhotoInDialog() {
            this.dialogs.imageDisplay = true;

            setTimeout(() => {
                let carouselImage = document
                    .querySelector(".v-window-item--active")
                    .querySelector(".carousel-image");
                let imageDisplayImageTag = document.querySelector(
                    "#imageDisplayImageTag"
                );
                imageDisplayImageTag.setAttribute(
                    "src",
                    carouselImage.getAttribute("src")
                );
            }, 250);
        },
        downloadPdf() {
            axios
                .get(route(`api.materials.download_pdf`, this.selectedMaterial.parent.id), {
                    responseType: "arraybuffer",
                })
                .then((response) => {
                    let blob = new Blob([response.data], {
                        type: "application/pdf",
                    });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "test.pdf";
                    link.click();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style scoped>
.material-description-container-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}
.material-description-container-vendor {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
.image-container {
    width: 25%;
}
.image-container img {
    width: 100%;
    height: auto;
}
.material-description-container {
    display: flex;
    flex-direction: column;
    width: 75%;
    padding: 0 20px;
}
.data-piece {
    margin: 13px 0;
}
.data-piece-2 {
    width: 100%;
    margin: 20px 0;
    grid-column: span 2;
}
@media (max-width: 1000px) {
    .image-container {
        max-height: 150px;
        overflow: hidden;
    }
}
@media (max-width: 750px) {
    .material-description-container-row {
        grid-template-columns: 1fr;
    }
    .image-container {
        width: 100%;
        max-height: 170px;
    }
    .material-description-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        padding: 0 10px;
    }
    .data-piece {
        margin: 7px 0;
    }
    .data-piece-2 {
        width: 100%;
        grid-column: span 2;
    }
}

.notes-container {
    width: 100%;
}
.data-piece .title,
.data-piece-2 .title,
.notes-container .title,
.recyclables-container .title {
    font-weight: 600;
    font-size: 20px;
}
.data-piece .value,
.data-piece-2 .value,
.notes-container .value,
.recyclables-container .value {
    font-style: italic;
    font-size: 15px;
}
.material-bottom-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.recyclables-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-top: 10px;
}
.bucket {
    display: flex;
    gap: 25px;
}
.material-bottom-container .recyclables-container div {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media (max-width: 750px) {
    .material-bottom-container {
        padding: 0;
        margin-top: 7px;
    }
    .recyclables-container {
        width: 100%;
        padding: 0 10px;
    }
    .material-bottom-container .recyclables-container div {
        flex-direction: column;
    }
    .material-bottom-container {
        flex-direction: column;
        width: 100%;
    }
    .notes-container {
        width: 100%;
        padding-left: 0;
        margin-top: 7px;
        padding: 0 10px;
    }
}
.notes-addition-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-grow: 1;
}
.carousel-container {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
}
@media (max-width: 750px) {
    .carousel-container {
        width: auto;
    }
}

.carousel-container .carousel {
    width: auto;
    height: 250px !important;
    border-radius: 8px;
}
#download-button {
    padding-left: 50px;
    color: rgb(1, 85, 165);
    transition: all ease-in 0.15s;
    cursor: pointer;
}
#download-button:hover {
    color: rgb(0, 174, 239);
}
</style>
